

// import React, { useState, useEffect, useRef, useCallback } from "react";
// import { Box, Typography, TextField, Button, Avatar, IconButton, useMediaQuery, useTheme } from "@mui/material";
// import AttachFileIcon from "@mui/icons-material/AttachFile";
// import { useParams } from "react-router-dom";
// import axios from "axios";

// const API_BASE = process.env.REACT_APP_API_URL;
// const token = localStorage.getItem("token");

// const avatarColor = (name = "") => {
//   const c = ['#00C2B3', '#0088A3', '#007A70', '#005A6E'];
//   let h = 0;
//   for (let i = 0; i < name.length; i++) h = name.charCodeAt(i) + ((h << 5) - h);
//   return c[Math.abs(h) % c.length];
// };

// function PrivateChat({ userId, username, socket }) {
//   const { userId: partnerId } = useParams();
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

//   const [partner, setPartner] = useState(null);
//   const [messages, setMessages] = useState([]);
//   const [input, setInput] = useState("");
//   const [file, setFile] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const messagesEndRef = useRef(null);

//   useEffect(() => {
//     if (!partnerId) return;
//     axios.get(`${API_BASE}/api/users/${partnerId}`, { headers: { Authorization: `Bearer ${token}` } })
//       .then(res => setPartner(res.data))
//       .catch(() => setPartner(null));
//   }, [partnerId]);

//   useEffect(() => {
//     if (!partnerId) return;
//     setLoading(true);
//     axios.get(`${API_BASE}/api/chat/private/${userId}/${partnerId}`, { headers: { Authorization: `Bearer ${token}` } })
//       .then(res => { setMessages(res.data); setLoading(false); })
//       .catch(() => { setMessages([]); setLoading(false); });
//   }, [partnerId, userId]);

//   useEffect(() => {
//     const handleIncoming = (msg) => {
//       if ((msg.from === userId && msg.to === partnerId) || (msg.from === partnerId && msg.to === userId))
//         setMessages(prev => [...prev, msg]);
//     };
//     socket.on("privateMessage", handleIncoming);
//     return () => socket.off("privateMessage", handleIncoming);
//   }, [partnerId, userId]);

//   useEffect(() => {
//     messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
//   }, [messages]);

//   const sendMessage = async () => {
//     if (!input.trim()) return;
//     const msg = { from: userId, to: partnerId, username, content: input.trim(), timestamp: new Date().toISOString() };
//     try {
//       await axios.post(`${API_BASE}/api/chat/private`, msg, { headers: { Authorization: `Bearer ${token}` } });
//     } catch (err) { console.error(err); }
//     socket.emit("privateMessage", msg);
//     setMessages(prev => [...prev, msg]);
//     setInput("");
//   };

//   const sendFile = async () => {
//     if (!file) return;
//     const formData = new FormData();
//     formData.append("file", file);
//     try {
//       const res = await axios.post(`${API_BASE}/api/upload`, formData, {
//         headers: { "Content-Type": "multipart/form-data", Authorization: `Bearer ${token}` },
//       });
//       const fileMsg = { from: userId, to: partnerId, username, fileUrl: res.data.fileUrl, timestamp: new Date().toISOString() };
//       await axios.post(`${API_BASE}/api/chat/private`, fileMsg, { headers: { Authorization: `Bearer ${token}` } });
//       socket.emit("privateMessage", fileMsg);
//       setMessages(prev => [...prev, fileMsg]);
//       setFile(null);
//     } catch (err) { console.error(err); }
//   };

//   return (
//     <Box sx={{ display: 'flex', flexDirection: 'column', height: '100vh', bgcolor: '#090C0F' }}>
//       {/* Header */}
//       <Box sx={{
//         px: 3, py: 2, bgcolor: '#0E1318', borderBottom: '1px solid #1A2228',
//         display: 'flex', alignItems: 'center', gap: 2, flexShrink: 0,
//       }}>
//         <Box sx={{ position: 'relative' }}>
//           <Avatar sx={{
//             width: 38, height: 38, fontSize: 14, fontWeight: 700,
//             bgcolor: avatarColor(partner?.username || partnerId || ''),
//           }}>
//             {(partner?.username || partnerId || '?')[0]?.toUpperCase()}
//           </Avatar>
//           <Box sx={{
//             position: 'absolute', bottom: 0, right: 0,
//             width: 10, height: 10, bgcolor: '#00C2B3',
//             borderRadius: '50%', border: '2px solid #0E1318',
//           }} />
//         </Box>
//         <Box>
//           <Typography sx={{ fontFamily: "'Outfit', sans-serif", fontWeight: 600, fontSize: 16, color: '#F0F4F8' }}>
//             {partner?.username || 'User'}
//           </Typography>
//           <Typography sx={{ fontFamily: "'Outfit', sans-serif", fontSize: 12, color: '#00C2B3' }}>
//             Active now
//           </Typography>
//         </Box>
//       </Box>

//       {/* Messages */}
//       <Box sx={{
//         flex: 1, overflowY: 'auto', px: { xs: 2, sm: 3 }, py: 2,
//         display: 'flex', flexDirection: 'column', gap: 0.5,
//         '&::-webkit-scrollbar': { width: 4 },
//         '&::-webkit-scrollbar-thumb': { bgcolor: '#1A2228', borderRadius: 4 },
//       }}>
//         {loading ? (
//           <Typography sx={{ fontFamily: "'Outfit', sans-serif", fontSize: 14, color: '#2A3A48', textAlign: 'center', mt: 4 }}>
//             Loading messages...
//           </Typography>
//         ) : messages.length === 0 ? (
//           <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', flex: 1, gap: 1.5 }}>
//             <Box sx={{ width: 56, height: 56, borderRadius: '50%', bgcolor: '#0E1318', border: '1px solid #1A2228', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
//               <Avatar sx={{ width: 40, height: 40, fontSize: 16, fontWeight: 700, bgcolor: avatarColor(partner?.username || '') }}>
//                 {(partner?.username || '?')[0]?.toUpperCase()}
//               </Avatar>
//             </Box>
//             <Typography sx={{ fontFamily: "'Outfit', sans-serif", fontSize: 15, color: '#F0F4F8', fontWeight: 600 }}>
//               {partner?.username || 'User'}
//             </Typography>
//             <Typography sx={{ fontFamily: "'Outfit', sans-serif", fontSize: 13, color: '#3A4A58' }}>
//               Send a message to start the conversation
//             </Typography>
//           </Box>
//         ) : (
//           messages.map((msg, idx) => {
//             const senderId = msg.from?._id || msg.from;
//             const isSender = String(senderId) === String(userId);

//             return (
//               <Box key={idx} sx={{
//                 display: 'flex', justifyContent: isSender ? 'flex-end' : 'flex-start',
//                 mb: 0.8,
//               }}>
//                 <Box sx={{
//                   display: 'flex',
//                   flexDirection: isSender ? 'row-reverse' : 'row',
//                   alignItems: 'flex-end', gap: 1,
//                   maxWidth: { xs: '80%', sm: '60%' },
//                 }}>
//                   {!isSender && (
//                     <Avatar sx={{
//                       width: 26, height: 26, fontSize: 10, fontWeight: 700,
//                       bgcolor: avatarColor(partner?.username || ''),
//                       flexShrink: 0, mb: 0.3,
//                     }}>
//                       {(partner?.username || '?')[0]?.toUpperCase()}
//                     </Avatar>
//                   )}
//                   <Box sx={{
//                     bgcolor: isSender ? '#0E2020' : '#0E1318',
//                     border: `1px solid ${isSender ? '#0A3530' : '#1A2228'}`,
//                     borderRadius: isSender ? '12px 4px 12px 12px' : '4px 12px 12px 12px',
//                     px: 2, py: 1.2,
//                   }}>
//                     {msg.content && (
//                       <Typography sx={{ fontFamily: "'Outfit', sans-serif", fontSize: 14, color: '#D0DCE8', lineHeight: 1.5 }}>
//                         {msg.content}
//                       </Typography>
//                     )}
//                     {msg.fileUrl && (
//                       msg.fileUrl.match(/\.(jpeg|jpg|png|gif|webp)$/i) ? (
//                         <a href={`${API_BASE}${msg.fileUrl}`} target="_blank" rel="noreferrer">
//                           <img src={`${API_BASE}${msg.fileUrl}`} alt="file" style={{ maxWidth: '100%', maxHeight: 200, borderRadius: 8, display: 'block' }} />
//                         </a>
//                       ) : (
//                         <a href={`${API_BASE}${msg.fileUrl}`} target="_blank" rel="noreferrer"
//                           style={{ color: '#00C2B3', textDecoration: 'none', fontFamily: "'Outfit', sans-serif", fontSize: 14 }}>
//                           📎 {msg.fileUrl.split("/").pop()}
//                         </a>
//                       )
//                     )}
//                     <Typography sx={{
//                       fontFamily: "'JetBrains Mono', monospace", fontSize: 10,
//                       color: '#2A3A48', mt: 0.5,
//                       textAlign: isSender ? 'right' : 'left',
//                     }}>
//                       {new Date(msg.timestamp).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
//                     </Typography>
//                   </Box>
//                 </Box>
//               </Box>
//             );
//           })
//         )}
//         <div ref={messagesEndRef} />
//       </Box>

//       {/* Input bar */}
//       <Box sx={{
//         px: 3, py: 2, bgcolor: '#0E1318', borderTop: '1px solid #1A2228',
//         display: 'flex', alignItems: 'center', gap: 1.5, flexShrink: 0,
//       }}>
//         <IconButton
//           component="label"
//           sx={{
//             width: 38, height: 38, borderRadius: '10px',
//             bgcolor: '#141B22', border: '1px solid #1A2228',
//             color: '#4A6070', flexShrink: 0,
//             '&:hover': { bgcolor: '#1A2530', color: '#00C2B3', borderColor: '#00C2B3' },
//           }}
//         >
//           <AttachFileIcon sx={{ fontSize: 18 }} />
//           <input type="file" hidden onChange={e => setFile(e.target.files[0])} />
//         </IconButton>

//         {file && (
//           <Button
//             onClick={sendFile}
//             sx={{
//               fontFamily: "'Outfit', sans-serif", fontSize: 12, textTransform: 'none',
//               color: '#00C2B3', border: '1px solid #00C2B3', borderRadius: '8px',
//               py: 0.7, px: 1.5, flexShrink: 0,
//               '&:hover': { bgcolor: '#0E2020' },
//             }}
//           >
//             Send file
//           </Button>
//         )}

//         <Box sx={{
//           flex: 1, bgcolor: '#141B22', border: '1px solid #1A2228',
//           borderRadius: '12px',
//           '&:focus-within': { borderColor: '#00C2B3' },
//         }}>
//           <TextField
//             fullWidth multiline maxRows={4}
//             placeholder={`Message ${partner?.username || 'User'}...`}
//             value={input}
//             onChange={e => setInput(e.target.value)}
//             onKeyDown={e => { if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); sendMessage(); } }}
//             variant="standard"
//             InputProps={{ disableUnderline: true }}
//             sx={{
//               px: 2, py: 1,
//               '& .MuiInputBase-root': { fontFamily: "'Outfit', sans-serif", fontSize: 14, color: '#D0DCE8' },
//               '& ::placeholder': { color: '#2A3A48' },
//             }}
//           />
//         </Box>

//         <Button
//           onClick={sendMessage}
//           disabled={!input.trim()}
//           sx={{
//             minWidth: 42, height: 42, borderRadius: '10px',
//             bgcolor: input.trim() ? '#00C2B3' : '#141B22',
//             border: `1px solid ${input.trim() ? '#00C2B3' : '#1A2228'}`,
//             color: input.trim() ? '#090C0F' : '#2A3A48',
//             p: 0, flexShrink: 0,
//             '&:hover': { bgcolor: input.trim() ? '#00D5C5' : '#1A2530' },
//             '&.Mui-disabled': { bgcolor: '#141B22', borderColor: '#1A2228' },
//           }}
//         >
//           <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
//             <path d="M22 2L11 13M22 2L15 22L11 13M22 2L2 9L11 13" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
//           </svg>
//         </Button>
//       </Box>
//     </Box>
//   );
// }

// export default PrivateChat;

import React, { useState, useEffect, useRef } from "react";
import {
  Box, Typography, TextField, Button, Avatar, IconButton,
  Tooltip, useMediaQuery, useTheme,
} from "@mui/material";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import CloseIcon from "@mui/icons-material/Close";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { triggerNotification } from "./NotificationSystem";

const API_BASE = process.env.REACT_APP_API_URL;
const token = localStorage.getItem("token");

const avatarColor = (name = "") => {
  const c = ['#00C2B3', '#0088A3', '#007A70', '#005A6E'];
  let h = 0;
  for (let i = 0; i < name.length; i++) h = name.charCodeAt(i) + ((h << 5) - h);
  return c[Math.abs(h) % c.length];
};

const getAvatarUrl = (photo) => {
  if (!photo) return undefined;
  if (photo.startsWith('http')) return photo;
  return `${API_BASE.replace(/\/+$/, '')}/${photo.replace(/^\/+/, '')}`;
};

const FilePreview = ({ fileUrl }) => {
  const url = `${API_BASE}${fileUrl}`;
  const name = fileUrl.split('/').pop();
  const isImage = /\.(jpeg|jpg|png|gif|webp)$/i.test(fileUrl);
  const isVideo = /\.(mp4|mov|webm)$/i.test(fileUrl);
  const isAudio = /\.(mp3|wav|ogg)$/i.test(fileUrl);

  if (isImage) return (
    <a href={url} target="_blank" rel="noopener noreferrer">
      <img src={url} alt={name} style={{ maxWidth: '100%', maxHeight: 220, borderRadius: 8, display: 'block', cursor: 'zoom-in' }} />
    </a>
  );
  if (isVideo) return <video src={url} controls style={{ maxWidth: '100%', borderRadius: 8 }} />;
  if (isAudio) return <audio src={url} controls style={{ width: '100%' }} />;
  return (
    <a href={url} target="_blank" rel="noopener noreferrer"
      style={{ color: '#00C2B3', textDecoration: 'none', fontFamily: "'Outfit', sans-serif", fontSize: 14, display: 'flex', alignItems: 'center', gap: 6 }}>
      📎 {name}
    </a>
  );
};

function PrivateChat({ userId, username, socket }) {
  const { userId: partnerId } = useParams();
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const [partner, setPartner] = useState(null);
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState("");
  const [file, setFile] = useState(null);
  const [filePreview, setFilePreview] = useState(null);
  const [loading, setLoading] = useState(true);
  const [uploading, setUploading] = useState(false);
  const [isTyping, setIsTyping] = useState(false);
  const [hoveredMsg, setHoveredMsg] = useState(null);

  const messagesEndRef = useRef(null);
  const typingTimeoutRef = useRef();
  const fileInputRef = useRef();

  useEffect(() => {
    if (!partnerId) return;
    axios.get(`${API_BASE}/api/users/${partnerId}`, { headers: { Authorization: `Bearer ${token}` } })
      .then(res => setPartner(res.data))
      .catch(() => setPartner(null));
  }, [partnerId]);

  // Load history
  useEffect(() => {
    if (!partnerId) return;
    setLoading(true);
    axios.get(`${API_BASE}/api/chat/private/${userId}/${partnerId}`, {
      headers: { Authorization: `Bearer ${token}` }
    })
      .then(res => setMessages(res.data))
      .catch(() => setMessages([]))
      .finally(() => setLoading(false));
  }, [partnerId, userId]);

  // Socket listeners
  useEffect(() => {
    const handleMsg = (msg) => {
      const fromStr = String(msg.from?._id || msg.from);
      const toStr = String(msg.to);
      if (
        (fromStr === String(userId) && toStr === String(partnerId)) ||
        (fromStr === String(partnerId) && toStr === String(userId))
      ) {
        setMessages(prev => {
          // Avoid duplicate from optimistic update
          if (prev.some(m => m._id && m._id === msg._id)) return prev;
          return [...prev, msg];
        });
        if (fromStr !== String(userId)) {
          triggerNotification({ from: msg.username || partner?.username, message: msg.content || '📎 File' });
        }
      }
    };

    const handleDeleted = ({ messageId }) => {
      setMessages(prev => prev.filter(m => m._id !== messageId));
    };

    const handleTyping = ({ from }) => {
      if (String(from) === String(partnerId)) setIsTyping(true);
    };
    const handleStopTyping = ({ from }) => {
      if (String(from) === String(partnerId)) setIsTyping(false);
    };

    socket.on("privateMessage", handleMsg);
    socket.on("privateMessageDeleted", handleDeleted);
    socket.on("typing", handleTyping);
    socket.on("stopTyping", handleStopTyping);

    return () => {
      socket.off("privateMessage", handleMsg);
      socket.off("privateMessageDeleted", handleDeleted);
      socket.off("typing", handleTyping);
      socket.off("stopTyping", handleStopTyping);
    };
  }, [partnerId, userId, partner]);

  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages, isTyping]);

  const emitTyping = () => {
    socket.emit("typing", { to: partnerId, username });
    clearTimeout(typingTimeoutRef.current);
    typingTimeoutRef.current = setTimeout(() => {
      socket.emit("stopTyping", { to: partnerId });
    }, 1500);
  };

  const sendMessage = () => {
    if (!input.trim()) return;
    // Emit to socket — server saves to DB and broadcasts back
    // Do NOT also POST to /api/chat/private (that causes double-save)
    socket.emit("privateMessage", {
      to: partnerId,
      content: input.trim(),
      timestamp: new Date().toISOString(),
    });
    socket.emit("stopTyping", { to: partnerId });
    setInput("");
  };

  const handleFileSelect = (e) => {
    const f = e.target.files[0];
    if (!f) return;
    setFile(f);
    setFilePreview(f.type.startsWith('image/') ? URL.createObjectURL(f) : null);
  };

  const clearFile = () => {
    setFile(null);
    setFilePreview(null);
    if (fileInputRef.current) fileInputRef.current.value = '';
  };

  const sendFile = async () => {
    if (!file) return;
    setUploading(true);
    const formData = new FormData();
    formData.append("file", file);
    try {
      const res = await axios.post(`${API_BASE}/api/upload`, formData, {
        headers: { "Content-Type": "multipart/form-data", Authorization: `Bearer ${token}` },
      });
      socket.emit("privateMessage", {
        to: partnerId,
        fileUrl: res.data.fileUrl,
        timestamp: new Date().toISOString(),
      });
      clearFile();
    } catch (err) {
      console.error("File upload failed", err);
    } finally {
      setUploading(false);
    }
  };

  const deleteMessage = (msgId) => {
    socket.emit("deletePrivateMessage", { messageId: msgId, to: partnerId });
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100vh', bgcolor: '#090C0F', pt: '56px' }}>
      {/* Header */}
      <Box sx={{
        px: { xs: 2, sm: 3 }, py: 1.5,
        bgcolor: '#0E1318', borderBottom: '1px solid #1A2228',
        display: 'flex', alignItems: 'center', gap: 2, flexShrink: 0,
      }}>
        {isMobile && (
          <IconButton onClick={() => navigate('/private/select')} sx={{ color: '#5A6A78', p: 0.5, mr: -0.5 }}>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
              <path d="M15 18l-6-6 6-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </IconButton>
        )}
        <Box sx={{ position: 'relative' }}>
          <Avatar
            src={getAvatarUrl(partner?.profilePhoto)}
            sx={{ width: 36, height: 36, fontSize: 13, fontWeight: 700, bgcolor: avatarColor(partner?.username || '') }}
          >
            {!partner?.profilePhoto && (partner?.username || '?')[0]?.toUpperCase()}
          </Avatar>
          <Box sx={{ position: 'absolute', bottom: 0, right: 0, width: 9, height: 9, bgcolor: '#00C2B3', borderRadius: '50%', border: '2px solid #0E1318' }} />
        </Box>
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <Typography sx={{ fontFamily: "'Outfit', sans-serif", fontWeight: 600, fontSize: 15, color: '#F0F4F8' }}>
            {partner?.username || 'User'}
          </Typography>
          <Typography sx={{ fontFamily: "'Outfit', sans-serif", fontSize: 11, color: isTyping ? '#00C2B3' : '#3A4A58' }}>
            {isTyping ? 'typing...' : 'Active now'}
          </Typography>
        </Box>
      </Box>

      {/* Messages */}
      <Box sx={{
        flex: 1, overflowY: 'auto', px: { xs: 1.5, sm: 3 }, py: 2,
        '&::-webkit-scrollbar': { width: 4 },
        '&::-webkit-scrollbar-thumb': { bgcolor: '#1A2228', borderRadius: 4 },
      }}>
        {loading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', pt: 6 }}>
            <Typography sx={{ fontFamily: "'Outfit', sans-serif", fontSize: 13, color: '#2A3A48' }}>Loading messages...</Typography>
          </Box>
        ) : messages.length === 0 ? (
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', pt: { xs: 6, sm: 10 }, gap: 1.5 }}>
            <Avatar
              src={getAvatarUrl(partner?.profilePhoto)}
              sx={{ width: 64, height: 64, fontSize: 22, fontWeight: 700, bgcolor: avatarColor(partner?.username || '') }}
            >
              {!partner?.profilePhoto && (partner?.username || '?')[0]?.toUpperCase()}
            </Avatar>
            <Typography sx={{ fontFamily: "'Outfit', sans-serif", fontSize: 16, color: '#F0F4F8', fontWeight: 600 }}>
              {partner?.username}
            </Typography>
            <Typography sx={{ fontFamily: "'Outfit', sans-serif", fontSize: 13, color: '#3A4A58' }}>
              Send a message to start chatting
            </Typography>
          </Box>
        ) : (
          messages.map((msg, idx) => {
            const fromStr = String(msg.from?._id || msg.from);
            const isSender = fromStr === String(userId);
            const prevMsg = idx > 0 ? messages[idx - 1] : null;
            const prevFrom = prevMsg ? String(prevMsg.from?._id || prevMsg.from) : null;
            const isSameUser = prevFrom === fromStr;
            const withinFive = prevMsg ? new Date(msg.timestamp) - new Date(prevMsg.timestamp) < 300000 : false;
            const hideHeader = isSameUser && withinFive;

            return (
              <Box
                key={msg._id || idx}
                onMouseEnter={() => setHoveredMsg(msg._id)}
                onMouseLeave={() => setHoveredMsg(null)}
                sx={{
                  display: 'flex',
                  justifyContent: isSender ? 'flex-end' : 'flex-start',
                  mb: hideHeader ? 0.4 : 1.5,
                }}
              >
                <Box sx={{
                  display: 'flex',
                  flexDirection: isSender ? 'row-reverse' : 'row',
                  alignItems: 'flex-end', gap: 1,
                  maxWidth: { xs: '85%', sm: '62%' },
                }}>
                  {!isSender && (
                    hideHeader
                      ? <Box sx={{ width: 26, flexShrink: 0 }} />
                      : (
                        <Avatar
                          src={getAvatarUrl(partner?.profilePhoto)}
                          sx={{ width: 26, height: 26, fontSize: 10, fontWeight: 700, bgcolor: avatarColor(partner?.username || ''), flexShrink: 0, mb: 0.3 }}
                        >
                          {!partner?.profilePhoto && (partner?.username || '?')[0]?.toUpperCase()}
                        </Avatar>
                      )
                  )}

                  <Box sx={{
                    bgcolor: isSender ? '#0E2020' : '#0E1318',
                    border: `1px solid ${isSender ? '#0A3530' : '#1A2228'}`,
                    borderRadius: isSender
                      ? (hideHeader ? '12px 4px 4px 12px' : '12px 4px 12px 12px')
                      : (hideHeader ? '4px 12px 12px 4px' : '4px 12px 12px 12px'),
                    px: 2, py: 1.2,
                  }}>
                    {msg.content && (
                      <Typography sx={{ fontFamily: "'Outfit', sans-serif", fontSize: 14, color: '#D0DCE8', lineHeight: 1.5, wordBreak: 'break-word' }}>
                        {msg.content}
                      </Typography>
                    )}
                    {msg.fileUrl && <FilePreview fileUrl={msg.fileUrl} />}
                    <Typography sx={{
                      fontFamily: "'JetBrains Mono', monospace", fontSize: 10, color: '#2A3A48',
                      mt: 0.5, textAlign: isSender ? 'right' : 'left',
                    }}>
                      {msg.timestamp ? new Date(msg.timestamp).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) : ''}
                    </Typography>
                  </Box>

                  {isSender && msg._id && hoveredMsg === msg._id && (
                    <Tooltip title="Delete" placement="top">
                      <IconButton
                        size="small"
                        onClick={() => deleteMessage(msg._id)}
                        sx={{ color: '#FF6B6B', p: 0.3, '&:hover': { bgcolor: '#1A0E0E' } }}
                      >
                        <DeleteOutlineIcon sx={{ fontSize: 15 }} />
                      </IconButton>
                    </Tooltip>
                  )}
                </Box>
              </Box>
            );
          })
        )}

        {isTyping && (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
            <Avatar
              src={getAvatarUrl(partner?.profilePhoto)}
              sx={{ width: 22, height: 22, fontSize: 9, bgcolor: avatarColor(partner?.username || '') }}
            >
              {partner?.username?.[0]?.toUpperCase()}
            </Avatar>
            <Box sx={{
              bgcolor: '#0E1318', border: '1px solid #1A2228',
              borderRadius: '4px 12px 12px 4px',
              px: 1.5, py: 1, display: 'flex', gap: 0.5, alignItems: 'center',
            }}>
              {[0,1,2].map(i => (
                <Box key={i} sx={{
                  width: 5, height: 5, borderRadius: '50%', bgcolor: '#00C2B3',
                  animation: `bounce 1.2s ${i * 0.2}s infinite`,
                  '@keyframes bounce': {
                    '0%, 100%': { transform: 'translateY(0)' },
                    '50%': { transform: 'translateY(-4px)' },
                  },
                }} />
              ))}
            </Box>
          </Box>
        )}
        <div ref={messagesEndRef} />
      </Box>

      {/* File preview strip */}
      {file && (
        <Box sx={{
          px: 3, py: 1.5, bgcolor: '#0E1318', borderTop: '1px solid #1A2228',
          display: 'flex', alignItems: 'center', gap: 2,
        }}>
          {filePreview
            ? <img src={filePreview} alt="preview" style={{ height: 52, width: 52, objectFit: 'cover', borderRadius: 8 }} />
            : <Box sx={{ width: 52, height: 52, bgcolor: '#141B22', border: '1px solid #1A2228', borderRadius: 8, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <Typography sx={{ fontSize: 20 }}>📎</Typography>
              </Box>
          }
          <Box sx={{ flex: 1, minWidth: 0 }}>
            <Typography sx={{ fontFamily: "'Outfit', sans-serif", fontSize: 13, color: '#F0F4F8', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
              {file.name}
            </Typography>
            <Typography sx={{ fontFamily: "'JetBrains Mono', monospace", fontSize: 11, color: '#3A4A58' }}>
              {(file.size / 1024).toFixed(0)} KB
            </Typography>
          </Box>
          <Button
            onClick={sendFile}
            disabled={uploading}
            sx={{
              fontFamily: "'Outfit', sans-serif", fontSize: 12, textTransform: 'none',
              bgcolor: '#00C2B3', color: '#090C0F', borderRadius: '8px', px: 2, py: 0.8,
              '&:hover': { bgcolor: '#00D5C5' }, flexShrink: 0,
            }}
          >
            {uploading ? 'Sending...' : 'Send'}
          </Button>
          <IconButton onClick={clearFile} size="small" sx={{ color: '#FF6B6B' }}>
            <CloseIcon fontSize="small" />
          </IconButton>
        </Box>
      )}

      {/* Input */}
      <Box sx={{
        px: { xs: 1.5, sm: 3 }, py: 1.5,
        bgcolor: '#0E1318', borderTop: '1px solid #1A2228',
        display: 'flex', alignItems: 'flex-end', gap: 1, flexShrink: 0,
      }}>
        <IconButton
          component="label"
          sx={{
            width: 38, height: 38, borderRadius: '10px',
            bgcolor: '#141B22', border: '1px solid #1A2228', color: '#4A6070', flexShrink: 0,
            '&:hover': { bgcolor: '#1A2530', color: '#00C2B3', borderColor: '#00C2B3' },
          }}
        >
          <AttachFileIcon sx={{ fontSize: 18 }} />
          <input type="file" hidden ref={fileInputRef} onChange={handleFileSelect} />
        </IconButton>

        <Box sx={{
          flex: 1, bgcolor: '#141B22', border: '1px solid #1A2228', borderRadius: '12px',
          '&:focus-within': { borderColor: '#00C2B3' },
        }}>
          <TextField
            fullWidth multiline maxRows={5}
            placeholder={`Message ${partner?.username || 'User'}...`}
            value={input}
            onChange={e => { setInput(e.target.value); emitTyping(); }}
            onKeyDown={e => { if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); sendMessage(); } }}
            variant="standard"
            InputProps={{ disableUnderline: true }}
            sx={{
              px: 2, py: 1,
              '& .MuiInputBase-root': { fontFamily: "'Outfit', sans-serif", fontSize: 14, color: '#D0DCE8' },
              '& textarea::placeholder': { color: '#2A3A48', opacity: 1 },
            }}
          />
        </Box>

        <IconButton
          onClick={sendMessage}
          disabled={!input.trim()}
          sx={{
            width: 38, height: 38, borderRadius: '10px', flexShrink: 0,
            bgcolor: input.trim() ? '#00C2B3' : '#141B22',
            border: `1px solid ${input.trim() ? '#00C2B3' : '#1A2228'}`,
            color: input.trim() ? '#090C0F' : '#2A3A48',
            '&:hover': { bgcolor: input.trim() ? '#00D5C5' : '#1A2530' },
            '&.Mui-disabled': { bgcolor: '#141B22', borderColor: '#1A2228', color: '#2A3A48' },
          }}
        >
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none">
            <path d="M22 2L11 13M22 2L15 22L11 13M22 2L2 9L11 13" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </IconButton>
      </Box>
    </Box>
  );
}

export default PrivateChat;